export const formatPrice = (price) => {
    let tempPrice = price;
    let newPrice = price.toString();
    let StringPrice = ''
    for (let i = 1; i < parseInt((newPrice.length-1)/3)+2; i++) {
        let start = newPrice.length-(i*3);
        let end = newPrice.length - ((i-1)*3);
        if (start < 0){
            tempPrice = newPrice.slice(0,end)
        } else {
            tempPrice = newPrice.slice(start,end)
        }
        if (i === 1){
            StringPrice = tempPrice;
        } else {
            StringPrice = tempPrice + ',' + StringPrice;
        }
        // console.log(start,end)  
    }
    return StringPrice;
}

export const makePersian = (price, lan=false) => {
    if(!price || !lan){
        return price;
    }
    
    let newPrice = price.toString();
    let StringPrice = ''
    let dict = ["۰","۱","۲","۳","۴","۵","۶","۷","۸","۹"];
    for (let i = 0; i < newPrice.length; i++) {
        const element = newPrice[i];
        if(dict[element]){
            StringPrice+= dict[element];
        } else {
            StringPrice+= element
        }
    }
    return StringPrice;
}